import { useVideoStore } from "@/stores/video";
import { buildSourceForVideoConfig } from "@/domain/GlobalFunctions/videoUrlHelper";

class VideoSyncManager {
  constructor() {
    this.timer = null;
    this.intervalMs = 30000; // default 30s
    this.running = false;
  }

  start(context, intervalSec = 30) {
    this.stop();
    this.intervalMs = Math.max(1, Number(intervalSec || 30)) * 1000;
    this.running = true;
    this._tick(context); // first run immediately
  }

  stop() {
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
    this.running = false;
  }

  async _tick(context) {
    if (!this.running) return;

    const startedAt = Date.now();
    const videoStore = useVideoStore();

    try {
      const variableService = new context.$variableService();
      const deviceService = new context.$deviceService();

      // 1) get videoConfigs from backend
      const elements = await variableService.listByVideo();
      const videoConfigs = (elements || []).filter((el) => el?.enable && el?.variableCode.code == "URL");
      const videoPresets = (elements || []).filter((el) => el?.enable && el?.variableCode.code == "ptz");

      // 2) collect unique device IDs
      const deviceIds = [
        ...new Set(
          videoConfigs.map((vc) => vc?.device?.id).filter((id) => id != null)
        ),
      ];

      // 3) load all devices
      const devicesById = {};
      await Promise.all(
        deviceIds.map(async (id) => {
          const dev = await deviceService.search(id);
          if (dev) devicesById[id] = dev;
        })
      );


      // 4) build presets per video
      const presetsByDeviceId = {};
      for (const vc of videoPresets) {

        const devId = vc?.device?.id;

        if (devId != null) {
          presetsByDeviceId[devId] = vc;
        }
      }

      // 5) build sources per videoConfig
      const sourcesByConfigId = {};
      for (const vc of videoConfigs) {

        const devId = vc?.device?.id;
        const device = devId != null ? devicesById[devId] : null;

        const isRealTime = !!device?.dynamicData?.dynamic_rtspEnabled;
        const ptzEnabled = !!device?.dynamicData?.dynamic_enablePtz;

        vc.realTime = isRealTime;
        vc.ptzEnabled = ptzEnabled;

        const { url } = buildSourceForVideoConfig(vc, device);
        if (vc.id != null) {
          sourcesByConfigId[vc.id] = url;
        }
      }

      console.log(presetsByDeviceId)
      // 5) push to store (reactivity)
      console.log("VideoSyncManager: synced", {
        videoConfigs,
        devicesById,
        sourcesByConfigId,
        presetsByDeviceId,
      });
      videoStore.setAll({ videoConfigs, devicesById, sourcesByConfigId, presetsByDeviceId });
    } catch (e) {
      console.error("VideoSyncManager: sync error", e);
    } finally {
      const duration = Date.now() - startedAt;
      // keep your same style: next delay = interval - duration, min 1s:
      let nextDelay = this.intervalMs - duration;
      if (nextDelay <= 0) {
        nextDelay = this.intervalMs;
      }

      if (this.running) {
        this.timer = setTimeout(() => this._tick(context), nextDelay);
      }
    }
  }
}

export const videoSyncManager = new VideoSyncManager();
